import gql from 'graphql-tag';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ExpiringCreditExpirationType } from '@/gql/graphql';
import type { GrantSupervisorRetentionOfferResult } from '@/models/payment';

export type GrantSupervisorRetentionOfferInput = {
  phoneNumber: string;
  reason: string;
  amount: number;
  expirationType: ExpiringCreditExpirationType | string;
  expirationValue: string;
};

export const grantSupervisorRetentionOffer = async (
  input: GrantSupervisorRetentionOfferInput,
): Promise<GrantSupervisorRetentionOfferResult> => {
  const response = await mutationExecute({
    mutation: gql`
      mutation GrantSupervisorRetentionOffer(
        $phoneNumber: String!
        $reason: String!
        $amount: Float!
        $expirationType: ExpiringCreditExpirationType!
        $expirationValue: String!
      ) {
        grantSupervisorRetentionOffer(
          phoneNumber: $phoneNumber
          reason: $reason
          amount: $amount
          expirationType: $expirationType
          expirationValue: $expirationValue
        ) {
          message
          expiringCredit {
            id
            service
            subsidyCount
            subsidyAmt
            subsidyType
            subsidyTarget
            promoCode
            expiresAt
            createdAt
          }
          history {
            id
            reason
            amount
            expirationType
            expirationValue
            expiresAt
            expiringCreditId
            plan
            notes
            createdAt
            userName
          }
        }
      }
    `,
    variables: input,
  });

  return response.data.grantSupervisorRetentionOffer;
};
